export const OPENAPI_PATH = "/api/helpdesk/openapi.yaml";
export const API_DOCS_MARKDOWN_PATH = "/api/helpdesk/docs.md";
export const API_DOCS_PAGE_PATH = "/developers/api";
